import { fork, all } from 'redux-saga/effects'
import faqSaga from '../containers/Faq/sagas'
import guideSaga from '../containers/Guide/sagas'
import tutorialsSaga from '../containers/Tutorials/sagas'
import relatedSaga from '../containers/RelatedContent/sagas'
import launchPadSaga from '../containers/LaunchPad/sagas'
import devicesSaga from '../containers/DeviceSlider/sagas'
import appSaga from '../containers/App/sagas'
import userEventSata from '../containers/UserEvents/sagas'
import trendingTopicsSaga from '../containers/TrendingTopics/sagas'
import searchSaga from '../containers/ESSearch/sagas'
import osearchSaga from '../containers/Osearch/sagas'
import mailerSaga from '../containers/ContentMailer/sagas'
import suggestedSaga from '../containers/SuggestedContent/sagas'
import faqListSaga from '../containers/FaqList/sagas'
import helpfulTopicsSaga from '../containers/HelpfulTopics/sagas'
import tutorialListSaga from '../containers/TutorialList/sagas'
import callControlSaga from '../containers/CallHandler/sagas'
import recentsSaga from '../containers/RecentTopics/sagas'
import homeSaga from '../containers/Home/sagas'
import favouritesSaga from '../containers/Favourites/sagas'
import bulletinSaga from '../containers/Bulletin/sagas'
import footprintsSaga from '../containers/Footprints/sagas'
import freeNavSaga from '../containers/FreeNavSlider/sagas'

export default function* rootSaga() {
  yield all([
    fork(faqSaga),
    fork(guideSaga),
    fork(tutorialsSaga),
    fork(relatedSaga),
    fork(devicesSaga),
    fork(userEventSata),
    fork(trendingTopicsSaga),
    fork(searchSaga),
    fork(osearchSaga),
    fork(mailerSaga),
    fork(suggestedSaga),
    fork(faqListSaga),
    fork(helpfulTopicsSaga),
    fork(tutorialListSaga),
    fork(callControlSaga),
    fork(recentsSaga),
    fork(homeSaga),
    fork(favouritesSaga),
    fork(bulletinSaga),
    fork(footprintsSaga),
    fork(freeNavSaga),
    fork(launchPadSaga),
    fork(appSaga)
  ])
}
